export default {
    name: 'App'
};